import React, { useState, useEffect, useRef } from "react";
import "./signup.scss";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import { IsValidEmail } from "../../../../utils/validationUtils";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { InputLabel, MenuItem, Select } from "@mui/material";
import { connect } from "react-redux";
import { graduationYearsListStart } from "../../../../redux/common/graduationYears";
import BackdropLoader from "../../../common/Loader";
import { sportsListStart } from "../../../../redux/common/allSports";
import { emailExistStart } from "../../../../redux/auth/signup/checkEmailExist";
import {
  getSignupData,
  removeSignupData,
  setSignupData,
} from "../../../../services/authService";
import { graduationMonthsListStart } from "../../../../redux/common/graduationMonth";
import EmailExists from "../claimProfile/claimProfileStep2/EmailExists";
import messagePopup from "../../../../utils/messagePopup";
const initialValues = {
  athleteActive: true,
  email: "",
  gender: "Male",
  graduation: "",
  graduationMonthValue: "",
  sport: "",
};

function SignupStep1(props) {
  const [fields, setFields] = useState({ ...initialValues });
  const [errors, setErrors] = React.useState({});
  const [emailModal, setEmailModal] = React.useState(false);
  const fakeInput = useRef(null);

  useEffect(() => {
    getSportsList(fields.gender);
  }, [fields.gender]);

  useEffect(() => {
    props.graduationYearsListStart();
    props.graduationMonthsListStart();
    const signupData = getSignupData();
    if (signupData) {
      const finalData = {
        athleteActive: signupData.role
          ? signupData.role === "ATHLETES"
            ? true
            : false
          : true,
        email: signupData.athleteEmail
          ? signupData.athleteEmail
          : signupData.parentEmailId
          ? signupData.parentEmailId
          : "",
        gender: signupData.gender ? signupData.gender : "Male",
        graduation: signupData.athleteGraduationYear
          ? signupData.athleteGraduationYear
          : new Date().getFullYear(),
        graduationMonthValue: signupData.graduationMonthValue
          ? signupData.graduationMonthValue
          : 0,
        sport: signupData.athleteSports ? signupData.athleteSports : "",
      };
      setFields({
        ...fields,
        ...finalData,
      });
    }
  }, []);

  const getSportsList = (gender) => {
    props.sportsListStart({ gender });
  };

  const handleTabsClick = (e, flag) => {
    removeSignupData();
    const athleteActive = flag === "athlete" ? true : false;
    setFields({
      ...fields,
      athleteActive,
    });
  };

  const handleValidation = (fieldname, e) => {
    let errorsT = errors;
    let formIsValid = true;
    let fieldValue = e ? (e.target ? e.target.value : e) : e;
    let updatedValue = fieldValue;
    //email validations
    if (fieldname === undefined || fieldname === "email") {
      if (fieldname === undefined) {
        fieldValue = fields["email"] ? fields["email"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["email"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["email"] = "Email Address is required";
      } else if (!IsValidEmail(updatedValue)) {
        formIsValid = false;
        errorsT["email"] = "Please enter Email in correct format";
      }
    }
    //graduation years validations
    if (fieldname === undefined || fieldname === "graduation") {
      if (fieldname === undefined) {
        fieldValue = fields["graduation"] ? fields["graduation"] : "";
        updatedValue =
          fieldValue == ""
            ? props.graduationYears.data.filter(
                (word) => word.yearValue == new Date().getFullYear()
              )[0].id
            : fieldValue;
      }
      delete errorsT["graduation"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["graduation"] = "HS Grad Year is required";
      }
    }

    //sport validations
    if (fieldname === undefined || fieldname === "sport") {
      if (fieldname === undefined) {
        fieldValue = fields["sport"] ? fields["sport"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["sport"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["sport"] = "Sport is required";
      }
    }
    setErrors({
      ...errorsT,
    });
    return {
      formIsValid,
      updatedValue,
    };
  };
  const handleChange = (field, e) => {
    //const { formIsValid, updatedValue } = handleValidation(field, e);
    setErrors({
      errorsT: "",
    });

    let fieldsT = fields;
    fieldsT[field] = e ? (e.target ? e.target.value : e) : e;

    setFields({
      ...fieldsT,
    });
  };

  const handleRadioChange = (field, e) => {
    setErrors({
      errorsT: "",
    });

    if (fields.gender) {
      if (fields.gender !== "Male") {
        fields.sport = "";
      } else if (fields.gender !== "Female") {
        fields.sport = "";
      }
    }
    let fieldsT = fields;
    fieldsT[field] = e ? (e.target ? e.target.value : e) : e;

    setFields({
      ...fieldsT,
    });
  };

  const handleEmailModalOpen = () => {
    messagePopup("", "Email id already exist for athlete", "error");
    //setEmailModal(true);
  };

  const handleSaveSignUpData = (existingParentData = null) => {
    const emailObj = fields.athleteActive
      ? {
          athleteEmail: fields.email,
        }
      : {
          parentEmailId: fields.email,
        };
    const finalData = {
      athleteGraduationYear:
        fields.graduation == ""
          ? props.graduationYears.data.filter(
              (word) => word.yearValue == new Date().getFullYear()
            )[0].id
          : fields.graduation,
      athleteSports: fields.sport,
      gender: fields.gender,
      role: fields.athleteActive ? "ATHLETES" : "GUARDIAN",
      ...emailObj,
      graduationMonthValue: fields.graduationMonthValue
        ? fields.graduationMonthValue
        : 0,
      isParentExist: existingParentData ? 1 : 0,
      parentFirstName: existingParentData
        ? existingParentData.parentFirstName
        : "",
      parentLastName: existingParentData
        ? existingParentData.parentLastName
        : "",
      parentPhoneNumber: existingParentData
        ? existingParentData.parentPhoneNumber
        : "",
      parentCountryCodeId: existingParentData
        ? existingParentData.parentCountryCodeId
        : null,
      parentZipCode: existingParentData ? existingParentData.parentZipCode : "",
      parentOutsideUsOrCanada: existingParentData
        ? existingParentData.parentOutsideUsOrCanada
        : "",
    };
    let signupData = getSignupData() ? getSignupData() : {};
    signupData = {
      ...signupData,
      ...finalData,
      completed: signupData.completed ? signupData.completed : "STEP1",
    };
    setSignupData(signupData);
    if (fields.athleteActive) {
      props.history.push("/sportforceAthleteSignup/K8-ao-TJ/step2");
    } else {
      props.history.push("/signupstep2/guardian");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { formIsValid, updatedValue } = handleValidation();
    if (formIsValid) {
      props.emailExistStart({
        data: {
          email: fields.email,
          role: fields.athleteActive ? "ATHLETES" : "GUARDIAN",
        },
        handleEmailModalOpen: handleEmailModalOpen,
        handleSaveSignUpData: handleSaveSignUpData,
      });
    } else {
      goTop();
    }
  };

  const goTop = () => {
    fakeInput.current.focus();
    fakeInput.current.select();
  };
  return (
    <div>
      {/* <Header /> */}

      <div className="signupContainerSection">
        <div className="signupContainer">
          <BackdropLoader
            open={
              props.graduationYears.loading ||
              props.sportsList.loading ||
              props.graduationMonths.loading
            }
          />
          <input className="fakeInput" type="text" ref={fakeInput} />
          <div className="signupHeader">
            <FormLabel>
              <h1>Sign Up</h1>
            </FormLabel>
          </div>
          <div className="signuAction">
            <div className="title">
              {/* <h2>
                Are you an athlete or a parent / guardian? <sup>*</sup>
              </h2> */}
              <h2>
                Are you an athlete <sup>*</sup>
              </h2>
            </div>
            <div className="tabsBtnBox">
              <div className="">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={fields.athleteActive ? "active" : "inactive"}
                  onClick={(e) => handleTabsClick(e, "athlete")}
                >
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="54.657"
                      height="37.583"
                      viewBox="0 0 54.657 37.583"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <g transform="translate(0 -76.191)">
                        <g transform="translate(0 76.191)">
                          <path
                            className="a"
                            d="M144.1,96.8h16.864a.8.8,0,0,0,0-1.6H144.1a.8.8,0,1,0,0,1.6Z"
                            transform="translate(-127.246 -93.069)"
                          />
                          <path
                            className="a"
                            d="M9.494,166.821H26.358a.8.8,0,1,0,0-1.6H9.494a.8.8,0,1,0,0,1.6Z"
                            transform="translate(-7.718 -155.241)"
                          />
                          <path
                            className="a"
                            d="M56.258,246.856a.8.8,0,0,0,.8.8H73.924a.8.8,0,1,0,0-1.6H57.06A.8.8,0,0,0,56.258,246.856Z"
                            transform="translate(-49.955 -227.022)"
                          />
                          <path
                            className="a"
                            d="M15.955,336.44H.8a.8.8,0,1,0,0,1.6H15.955a.8.8,0,1,0,0-1.6Z"
                            transform="translate(0 -307.28)"
                          />
                          <path
                            className="a"
                            d="M350.993,84.956a4.382,4.382,0,1,0-4.383-4.383A4.382,4.382,0,0,0,350.993,84.956Z"
                            transform="translate(-307.774 -76.191)"
                          />
                          <path
                            className="a"
                            d="M188.512,135.126c-2.516,3.525-5.886,3.933-9.512,1.78-.247-.146-1.342-.75-1.584-.894-5.833-3.463-11.66-2.1-15.567,3.367-1.66,2.327,2.18,4.533,3.822,2.233,2.019-2.827,4.586-3.645,7.393-2.75-1.438,2.5-2.694,4.975-4.468,8.5s-5.69,6.338-9.454,4.137c-2.715-1.587-5.164,2.314-2.457,3.9a11.106,11.106,0,0,0,14.237-2.744,2.411,2.411,0,0,0,.343.152,28.429,28.429,0,0,1,6.809,4.031c1,.826,2.727,5.033,3.75,7.147,1.242,2.565,5.252.7,4.005-1.879-1.16-2.4-3.108-7.185-4.627-8.4a38.107,38.107,0,0,0-5.59-3.8q2.036-3.944,4.259-7.786c4.743,1.453,9.251-.259,12.461-4.756C193.995,135.032,190.155,132.826,188.512,135.126Z"
                            transform="translate(-138.084 -127.623)"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span className="label">Athlete</span>
                </Button>
              </div>
              {/* <div className="">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={!fields.athleteActive ? "active" : "inactive"}
                  onClick={(e) => handleTabsClick(e, "gaurdian")}
                >
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40.002"
                      height="42.271"
                      viewBox="0 0 40.002 42.271"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <g transform="translate(0 -18.766)">
                        <g transform="translate(0 26.832)">
                          <g transform="translate(0 0)">
                            <path
                              className="a"
                              d="M13.065,109.31H4.035a3.981,3.981,0,0,0-3.973,3.953L0,125.6a1.679,1.679,0,0,0,1.67,1.687h.009a1.679,1.679,0,0,0,1.679-1.67l.062-12.333v0a.333.333,0,0,1,.666,0V141.5a2.015,2.015,0,0,0,4.029,0V125.4h.87v16.1a2.014,2.014,0,0,0,4.029,0c0-26.629-.036-11.4-.037-28.2a.352.352,0,0,1,.7-.028h0L13.668,125.6a1.679,1.679,0,0,0,1.677,1.68h0a1.679,1.679,0,0,0,1.679-1.677l.011-12.333s0-.007,0-.01A3.981,3.981,0,0,0,13.065,109.31Z"
                              transform="translate(0 -109.31)"
                            />
                          </g>
                        </g>
                        <g transform="translate(5.071 18.766)">
                          <circle
                            className="a"
                            cx="3.479"
                            cy="3.479"
                            r="3.479"
                          />
                        </g>
                        <g transform="translate(19.175 26.774)">
                          <g transform="translate(0 0)">
                            <path
                              className="a"
                              d="M298.96,123.969c-.031-.088-3.084-8.795-3.564-10.193-.773-2.25-2.07-3.391-3.853-3.391h-5.8c-1.784,0-3.08,1.141-3.853,3.391-.48,1.4-3.533,10.1-3.564,10.193a1.667,1.667,0,0,0,3.145,1.1c.1-.281,1.935-5.384,2.96-8.32-.107.876.2-.942-2.382,12.4a.928.928,0,0,0,.909,1.1h1.272V142.34a2,2,0,0,0,4,0V130.252h.863V142.34a2,2,0,0,0,4,0V130.252h1.272a.926.926,0,0,0,.909-1.1c-2.56-13.218-2.278-11.683-2.365-12.4,1.033,2.959,2.815,8.044,2.912,8.32a1.666,1.666,0,1,0,3.145-1.1Z"
                              transform="translate(-278.228 -110.386)"
                            />
                          </g>
                        </g>
                        <g transform="translate(26.149 18.766)">
                          <g transform="translate(0 0)">
                            <circle
                              className="a"
                              cx="3.454"
                              cy="3.454"
                              r="3.454"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span className="label">Parent / Guardian</span>
                </Button>
              </div> */}
            </div>
          </div>
          <p className="subHead">
            <span className="checkIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <defs>
                  <style></style>
                </defs>
                <g transform="translate(-649.111 -507.111)">
                  <path
                    className="a"
                    d="M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,0"
                    transform="translate(649.111 507.111)"
                  />
                  <path
                    className="b"
                    d="M152.6,167.008l-6.4,6.4a.983.983,0,0,1-1.391,0l-3.2-3.2a.984.984,0,1,1,1.391-1.391l2.5,2.5,5.7-5.7a.984.984,0,1,1,1.391,1.391Zm0,0"
                    transform="translate(511.436 348.256)"
                  />
                </g>
              </svg>
            </span>
            Profile Verification Requirement
          </p>
          <div className="signup-athlete">
            <form autoComplete="off">
              <div className="emailBoxField">
                <FormLabel>
                  <h2>
                    Athlete Email <sup>*</sup>
                  </h2>
                </FormLabel>
                <h2>The email will be used to login to your account</h2>
                <div className="fieldBox">
                  {/* <input id="email" type="email" value={fields.email} placeholder="Email Address"  onChange={(e) => {
                      handleChange("email", e);
                    }} /> */}
                  <TextField
                    fullWidth
                    variant="outlined"
                    id="email"
                    placeholder="Email Address"
                    type="text"
                    value={fields.email}
                    onChange={(e) => {
                      handleChange("email", e);
                    }}
                    onBlur={(e) => {
                      handleChange("email", e);
                    }}
                    InputProps={{
                      readOnly: false,
                    }}
                    required
                  />
                  <div className="error">{errors["email"]}</div>
                </div>
              </div>
              <div className="graduateYearBox">
                <FormLabel>
                  <h2>
                    Athlete HS Grad Year <sup>*</sup>
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <g transform="translate(-649.111 -507.111)">
                          <path
                            className="a"
                            d="M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,0"
                            transform="translate(649.111 507.111)"
                          />
                          <path
                            className="b"
                            d="M152.6,167.008l-6.4,6.4a.983.983,0,0,1-1.391,0l-3.2-3.2a.984.984,0,1,1,1.391-1.391l2.5,2.5,5.7-5.7a.984.984,0,1,1,1.391,1.391Zm0,0"
                            transform="translate(511.436 348.256)"
                          />
                        </g>
                      </svg>
                    </span>
                  </h2>
                </FormLabel>
                <div className="fieldBox">
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Select
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={
                        fields.graduation == ""
                          ? props.graduationYears.data
                            ? props.graduationYears.data.filter(
                                (word) =>
                                  word.yearValue == new Date().getFullYear()
                              )[0].id
                            : ""
                          : fields.graduation
                      }
                      onChange={(e) => handleChange("graduation", e)}
                      label="Select"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {props.graduationYears.data &&
                        props.graduationYears.data.map((item, index) => (
                          <MenuItem key={index} value={item.id}>
                            {item.yearValue}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                  <div className="error">{errors["graduation"]}</div>
                </div>
              </div>
              <div className="genderBox">
                <h2>
                  Athlete Gender <sup>*</sup>
                </h2>
                <div className="sf-radio-global">
                  <FormControl component="fieldset">
                    <FormLabel component="legend"></FormLabel>
                    <RadioGroup
                      name="radioGroup1"
                      row
                      value={fields.gender || "male"}
                      onChange={(e) => handleRadioChange("gender", e)}
                    >
                      <FormControlLabel
                        control={
                          <Radio name="radiobuttons_option_C402B5A8-880B-4F2A-9CFA-94C7DA4E95A5" />
                        }
                        label="Male"
                        value="Male"
                      />
                      <FormControlLabel
                        control={
                          <Radio name="radiobuttons_option_AE894437-7C35-407F-A289-26D78B41FA9A" />
                        }
                        label="Female"
                        value="Female"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
              <div className="sportBox">
                <FormLabel>
                  {" "}
                  <h2>
                    Athlete Sport <sup>*</sup>
                  </h2>
                </FormLabel>
                <div className="fieldBox">
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Select
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={fields.sport}
                      onChange={(e) => handleChange("sport", e)}
                      label="Select"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {props.sportsList.data &&
                        props.sportsList.data.map((item, index) => {
                         if(item?.id == 1 || item?.id == 4){
                           return (
                               <MenuItem key={index} value={item.id}>
                                 {item.sportName}
                               </MenuItem>
                           )
                         }
                        })}
                    </Select>
                  </FormControl>
                  <div className="error">{errors["sport"]}</div>
                </div>
              </div>
              <div className="continueBtnBox">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={(e) => {
                    handleSubmit(e);
                  }}
                  id="continue"
                  size="large"
                >
                  Continue
                </Button>
              </div>
              {emailModal == true ? (
                <EmailExists userEmail={fields.email} isRedirect={()=>setEmailModal(false)}/>
              ) : null}

              <div className="signInLinkBox">
                <p>
                  <span>If you have an account? </span>
                  <Link to="/login">Log In</Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    graduationYears: state.common.graduationYears,
    sportsList: state.common.sportsList,
    graduationMonths: state.common.graduationMonths,
    isEmailExist: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    graduationYearsListStart: () => dispatch(graduationYearsListStart()),
    graduationMonthsListStart: () => dispatch(graduationMonthsListStart()),
    sportsListStart: (data) => dispatch(sportsListStart(data)),
    emailExistStart: (data) => dispatch(emailExistStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupStep1);
